import {batch} from 'react-redux';
import {
  setReteachPlates,
  setReteachPlateLastViewMode,
  resetReteachPlateState,
  removeUpdatedPlate,
} from '../actions/reteachPlateAction';
import {PlateType, ViewMode} from '../../constants/dataEnum';
import {changeView} from '../actions/appStateAction';
import {PlateTypeName} from '../../contents/PlateTypeEditor/PlateTypeEditorEnum';
import {openAutoReteachPage} from './menuBusiness';

export const proceedReteachImportedProtocol = (newPlates) => (dispatch) => {
  const plates = newPlates.map((lab) => {
    // change to string if got labware type with 'number' datatype -> TODO: remove this if the implementation of the Enums in REST API in backend has been fixed
    if (lab?.type && typeof lab.type === 'number') {
      lab.type = PlateTypeName[lab.type] || PlateType.MICROPLATE;
    }

    return lab;
  });
  batch(() => {
    dispatch(resetReteachPlateState());
    dispatch(setReteachPlates(plates));
    dispatch(setReteachPlateLastViewMode(ViewMode.EXPLORER));
    dispatch(openAutoReteachPage());
  });
};

export const proceedReteachImportedLabware = (newPlates) => (dispatch) => {
  batch(() => {
    dispatch(resetReteachPlateState());
    dispatch(setReteachPlates(newPlates));
    dispatch(setReteachPlateLastViewMode(ViewMode.LABWARE_MANAGER));
    dispatch(openAutoReteachPage());
  });
};

export const exitReteachPlatePage = () => (dispatch, getState) => {
  const {reteachPlateState} = getState();
  const {lastViewMode} = reteachPlateState;

  batch(() => {
    dispatch(resetReteachPlateState());
    dispatch(changeView(lastViewMode));
  });
};

export const redirectToReteachPlatePage = () => (dispatch, getState) => {
  const {reteachPlateState} = getState();
  const {lastViewMode, reteachPlates} = reteachPlateState;

  if (reteachPlates?.length > 0) {
    dispatch(openAutoReteachPage());
  } else {
    // change view to lastViewMode if reteachPlates not exist
    dispatch(changeView(lastViewMode));
  }
};

export const removeUpdatedPlateFromReteachPlateState = (plateId) => (dispatch) => {
  dispatch(removeUpdatedPlate(plateId));
};
